import { useEffect, useState, ChangeEvent } from 'react';
import Converters from './Converters';
import InputField from './InputField';
import Card from './Cards';
import { useTranslation } from 'react-i18next';

interface GravityValues {
  blg: string | number;
  sg: string | number;
}

export default function Gravity() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('gravity.pageTitle');
  }, [t]);

  const [values, setValues] = useState<GravityValues>({ blg: 12, sg: 1.048 });

  function handleOnChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    if (name === 'blg') {
      setValues({ blg: value, sg: Converters.blgToGravity(Number(value)).toFixed(3) });
    } else {
      setValues({ blg: Converters.gravityToPlato(Number(value)).toFixed(1), sg: value });
    }
  }

  return (
    <div className="max-w-sm">
      <Card title={t('gravity.cardTitle')}>
        <InputField name="blg" label="BLG" step="0.01" value={values.blg} unit="BLG" onChange={handleOnChange} />
        <InputField name="sg" label="SG (Specific Gravity)" step="0.001" value={values.sg} unit="SG" onChange={handleOnChange} />
      </Card>
    </div>
  );
}
